import React, { Fragment } from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import cx from "classnames";
import { Col, Row } from "react-bootstrap";
import data from '@emoji-mart/data';
import Picker from '@emoji-mart/react';
import { Input } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFloppyDisk, faPlus } from "@fortawesome/free-solid-svg-icons";
//import { Editor } from 'react-draft-wysiwyg';
// import {
//     ContentState,
//     convertToRaw,
//     EditorState,
//     convertFromHTML,
//     BlockMapBuilder,
//     Modifier,
//     RichUtils
// } from 'draft-js';
//import draftToHtml from 'draftjs-to-html';
//import htmlToDraft from 'html-to-draftjs';
import BodyComponent from "../Campaigns/BodyComponent";
import {
    decodeString,
    getFieldValuefromComponent, getSessionValue,
    getWABodyVariables, getWAComponents, htmlToDraftBlocks, parseJSON,
    replaceHtmlToString,
    replaceStringTohtml, trimSpaces, uploadFileIntoS3,
    populateCurrentFormDetail, getVariableIndexSort, removeUnnecessoryVariable,
    showToast,
    confirmBoxWithImage,
    populateRecipientOptionList,
    getFormNameandLabel,
    replaceBetweenSpaceTags,
    getFieldsByFormname,
    randomNumber,
    normalizeTemplateVariables
} from "../../Common/Appcommon";
import Icon from "../../../src/Components/Inbox/components/Icon";
import { faXmark } from "@fortawesome/free-solid-svg-icons/faXmark";
import requestApi from "../../services/requestApi.service";
import Select from "react-select";
import CommonHeaderContent from "../../Common/CommonHeaderContent";
import Common from "../../Common/Common";
import CratioFileUploader from "../Common/CratioFileUploader";
import ChatbotList from './ChatbotList';
import PreviewPanel from '../WhatsappComponents/PreviewPanel';
import WhatsappComponent from '../../Common/WhatsappComponent';
import { Controller } from 'react-hook-form';
import WhatsappAction from '../Workflow/Actions/WhatsappAction';
import CKEditorComponent from '../../Common/CKEditor/CKEditorComponent';
import { Message } from 'rsuite';

class ReplyTemplate extends React.Component {

    variationIds = [];
    leadUpdateVariationIds = [];
    leadFormname = getSessionValue('leadformname');
    editorMaxLength = 1024;
    messageBoxzindex = false;
    chatMSGForm = process.env.REACT_APP_CHATBOTMESSAGE_FORMNAME;
    submitRef = React.createRef();
    submitWPRef = React.createRef();
    constructor(props) {
        super(props);

        const type = props.type || `quick-reply`;
      //  const content = ContentState.createFromText('');
        this.messageRef = React.createRef();

        this.state = {
            formData: { ...props.replyTemplateData } || {},
            showEmojis: false,
            editorState: "", //EditorState.createWithContent(content),
            type: type,
            variationsCount: 0,
            leadUpdateVariationsCount: 1,
            formsList: [],
            selectedForm: [],
            fields: [],
            isIAMessage: false,
            isResolveLead: false,
            iaMessagesList: [],
            defaultMessage: {},
            isUpdateLead: false,
            updateLeadConfig: [],
            isModal: (type !== "auto-reply"),
            messageBoxRequired: false,
            editorErrorMsg: "",
            editorWordCount: 0,
            selectedTemplate: [],
            selectedFormDetails: [],
            resetVariables: false,
            messageBoxzindex: false,
            variablesIndexNo: [],
            showLoader: false,
            chatMessageCount: 1,
            chatbotMessages: [],
            chatbotMessage: {},
            isChatbotModel: false,
            selectedChatbotMSG: "",
            messageOrder: [],
            chatbotMessageIds: [],
            components: [],
            waComponents: {},
            previewData: { ...props.previewData } || {},
            channelRecipientOptions: [],
            recipientOptions: [],
            fieldsOption: [],
            variableCount: "",
            varaction: ""
        }
    }

    componentDidMount = async () => {
        this.setState({
            showLoader: true,
            variableCount: "", 
             varaction: ""
        })
        if (this.props.type === "auto-reply") {
            await this.getChatBotReplyMessage();
        }
        if (this.props.type === "auto-reply" || this.props.type === "quick-reply") {
            await this.getFormNameByMobileNo();
        }
        if (this.props.type === "auto-reply" || this.props.type === "inboxSettings") {
            await this.loadIAMessageList();
        }
        //await this.prepareEditInfo();

        let selectedFormDetails = await this.getFormDetail(this.state.formData['formname']);
        let variableIndexNo = getVariableIndexSort(this.state.formData);
        let optionList = [];
        if (this.props.type === "workflowAction") {
            let fieldDetails = selectedFormDetails.length > 0 ? selectedFormDetails[1] : [];
            optionList = await populateRecipientOptionList(fieldDetails, "whatsapp");

        }
        this.setState({
            selectedFormDetails: selectedFormDetails,
            variablesIndexNo: variableIndexNo,
            channelRecipientOptions: optionList
        })
        await this.prepareEditInfo();
        this.setState({
            showLoader: false,
        })
    }

    loadIAMessageList = async () => {
        let params = {
            "ENTITY": "WHATSAPPPROCESS",
            "OPERATION": "INTERACTIVE_MESSAGE",
            "SETTINGSNAME": "GETALL",
        };
        let iaListMessages = [];
        let iaButtonMessages = [];
        let defaultMessage = {};
        let iaMessageId = this.state.formData['ia_message_id'];
        let convoStatus = this.state.formData['update_convo_status'];
        let response = await requestApi.processServerRequest(params, "WebV2", "get");
        if (response.issuccess) {
            let data = response.data;
            let iaData = data[0];
            if (data !== undefined && data[0][0] !== undefined && data[0][0] !== '') {
                for (let i = 0; i < iaData.length; i++) {
                    let mType = iaData[i]['message_type'];
                    if (mType === "list") {
                        iaListMessages.push({ value: iaData[i]['id'], label: iaData[i]['name'], type: mType });
                    } else if (mType === "button") {
                        iaButtonMessages.push({ value: iaData[i]['id'], label: iaData[i]['name'], type: mType });
                    }
                    if (i === 0) {
                        defaultMessage = iaListMessages[i];
                    }

                    if (iaMessageId === iaData[i]['id']) {
                        defaultMessage = { value: iaData[i]['id'], label: iaData[i]['name'], type: mType };
                    }
                }
            }
        }

        let isIAMessage = (iaMessageId !== undefined && iaMessageId !== null && iaMessageId !== '');
        let resolveStatus = false;
        if (convoStatus !== undefined && convoStatus !== null && convoStatus == '1') {
            resolveStatus = true;
        }
        let iaMessagesList = [
            {
                label: "List",
                options: iaListMessages
            },
            {
                label: "Button",
                options: iaButtonMessages
            }
        ]

        this.setState({
            iaMessagesList, defaultMessage, isIAMessage, isResolveLead: resolveStatus
        })
    }

    // onEditorStateChange = (editorState) => {
    //     let { formData, editorWordCount, messageBoxRequired, editorErrorMsg, type, variablesIndexNo, chatbotMessage } = this.state;

    //     if (type === 'auto-reply') {
    //         if (chatbotMessage['Message'] === undefined) {
    //             chatbotMessage['Message'] = '';
    //         }
    //         chatbotMessage['Message'] = draftToHtml(convertToRaw(editorState.getCurrentContent()));
    //         chatbotMessage['Message'] = replaceHtmlToString(chatbotMessage['Message']);
    //         chatbotMessage['Message'] = chatbotMessage['Message'].trimEnd();
    //         editorWordCount = chatbotMessage['Message'].length;
    //     }

    //     if (formData['Message'] === undefined) {
    //         formData['Message'] = '';
    //     }
    //     if (type !== 'auto-reply') {
    //         formData = removeUnnecessoryVariable(formData, variablesIndexNo);
    //         //convert html to string.
    //         formData['Message'] = draftToHtml(convertToRaw(editorState.getCurrentContent()));
    //         formData['Message'] = replaceHtmlToString(formData['Message']);
    //         formData['Message'] = formData['Message'].trimEnd();

    //         editorWordCount = formData['Message'].length;
    //     }

    //     if (type === 'auto-reply') {
    //         if (editorWordCount > this.editorMaxLength) {
    //             messageBoxRequired = true;
    //             editorErrorMsg = "Value too long";
    //         } else {
    //             messageBoxRequired = false;
    //             editorErrorMsg = "";
    //         }
    //     }

    //     if (type === 'inboxSettings' || type === 'optin_message' || type === 'optout_message') {
    //         if (!editorWordCount > 0) {
    //             messageBoxRequired = true;
    //             editorErrorMsg = "Message is needed";
    //         } else {
    //             messageBoxRequired = false;
    //             editorErrorMsg = "";
    //         }
    //     }

    //     this.setState({
    //         editorState, formData, editorWordCount, messageBoxRequired, editorErrorMsg, chatbotMessage
    //     });
    // };

    getFormNameByMobileNo = async () => {

        let isEnabledList = {
            "isAddonEnabled": true,
            "isWsappEnabled": true,
            "isProfileEnabled": true,
            "type": this.state.type,
            "isContactRef": true
        };

        let response = await getFormNameandLabel(isEnabledList);

        if (response.issuccess) {
            let data = response.data;
            this.setState({
                formsList: data
            })
        }
    }

    getFieldsByFormname = async (formname = this.leadFormname) => {

        let formDetail = [];
        let leadTemplateOptions = [];

        let skipFields = [
            `${this.leadFormname}_id`,
            'Lead_ID',
            'wsapp_recent_activity',
            'wsapp_convo_status',
            'wsapp_unread_count',
            'wsapp_optin_status',
            'wsapp_recent_msg_id',
            'wsapp_enabled',
            'wsapp_blocked',
            'wsapp_opt',
            'wsapp_last_delivered',
            'wsapp_last_read',
            'wsapp_last_replied',
            'wsapp_last_sent_msg_id',
            'wsapp_last_sent_msg_id',
            'wsapp_completed_campaign'
        ];


        formDetail = await this.populateFormDetail(formDetail, formname);
        let fieldDetails = formDetail[1];
        fieldDetails && fieldDetails.map((field) => {
            let fieldName = field[2];
            let fieldLabel = field[3];
            let fieldType = field[4];
            let isConfigHide = parseInt(field[10]);
            let isViewHide = parseInt(field[11]);
            if (!isConfigHide && !isViewHide) {
                if (fieldType !== 'subtable' && fieldType !== 'reference_entityid' && fieldType !== "reference_group" && fieldType !== "form_history") {
                    if (!skipFields.includes(fieldName)) {
                        if (fieldLabel !== undefined && fieldName !== undefined) {
                            leadTemplateOptions.push({
                                value: fieldName, label: fieldLabel
                            })
                        }
                    }
                }
            }
        });

        this.setState({
            fields: leadTemplateOptions
        })
    }

    populateFormDetail = async (formDetail, formname) => {
        return await populateCurrentFormDetail(this.props, formDetail, formname);
    }

    // onBoldClick = (e) => {

    //     let { editorState } = this.state;

    //     e.preventDefault();
    //     this.onEditorStateChange(RichUtils.toggleInlineStyle(
    //         editorState, 'BOLD'));
    // }

    // onItalicClick = (e) => {

    //     let { editorState } = this.state;

    //     e.preventDefault();
    //     this.onEditorStateChange(RichUtils.toggleInlineStyle(
    //         editorState, 'ITALIC'));
    // }

    // onStrikeClick = (e) => {

    //     let { editorState } = this.state;

    //     e.preventDefault();
    //     this.onEditorStateChange(RichUtils.toggleInlineStyle(
    //         editorState, 'STRIKETHROUGH'));
    // }

    toggleEmoji = () => {
        let { showEmojis } = this.state;
        this.setState({ showEmojis: !showEmojis });
    }

    showEmoji = () => {
        this.setState({ showEmojis: true });
    }

    addEmoji = (emojiObject) => {
        if (emojiObject.native) {
            this.setState({ 
                varaction: "insertEmoji",
                variableCount: emojiObject.native+"#$#"+randomNumber()
            });
        }
    };

    getChatbotMessage = async (chatbotid, msgid) => {
        let { editorState, editorWordCount, isIAMessage,chatbotMessage } = this.state;
        let result = [];
        let params = {
            "ENTITY": "WHATSAPPPROCESS",
            "OPERATION": "GET_CHATBOT_MESSAGES",
            "FORMID": chatbotid,
            "MESSAGEID": msgid,
            "isOtherApiReq": true,
        };
        let response = await requestApi.processServerRequest(params);
        if (response.issuccess) {
            let data = response.data;
            result = data[0] ? data[0] : {};
           // const decodedHtml = decodeHtmlEntities(result['Message']);
             if (Object.keys(result).length === 0) {
            //chatbotMessage = {};
            //     editorState = EditorState.createEmpty();
            //     editorWordCount = 0;
            //     isIAMessage = false;
             }

            this.setState({
                chatbotMessage: result,
                editorState,
                editorWordCount,
                isIAMessage
            })
        }

        return result;
    }

    prepareChatbotMessage = async (messageid) => {
        let { formData, editorState, editorWordCount, selectedChatbotMSG } = this.state;
        let chatbotMessage = await this.getChatbotMessage(formData['table_66_id'], messageid);
        if (chatbotMessage && chatbotMessage['Message'] !== undefined && chatbotMessage['Message'] !== null && chatbotMessage['Message'] !== "") {
            const plainText = chatbotMessage['Message']
       .replace(/<[^>]*>/g, '')        // Remove HTML tags
       .replace(/&nbsp;/g, ' ');     // Replace &nbsp; with a regular space
       const characterCount = Array.from(plainText).length;
            // chatbotMessage['Message'] = decodeString(chatbotMessage['Message'], true);
           /// chatbotMessage['Message'] = chatbotMessage['Message'].trimEnd();
            editorWordCount = characterCount; //chatbotMessage['Message'].length;
           // let html = replaceStringTohtml(chatbotMessage['Message']);
           // html = replaceBetweenSpaceTags(html);
            //editorState = htmlToDraftBlocks(html);
        } else {
            //let html = replaceStringTohtml("");
           // editorState = htmlToDraftBlocks(html);
        }

        chatbotMessage = getFieldValuefromComponent(chatbotMessage, chatbotMessage['components']);
        let defaultMessage = chatbotMessage['IAMessage'];
        let isIAMessage = false

        if (defaultMessage && defaultMessage !== null && defaultMessage !== "null" && defaultMessage !== "") {
            defaultMessage = parseJSON(defaultMessage);
            isIAMessage = true
        }

        this.setState({
            defaultMessage,
            isIAMessage: isIAMessage,
            editorState,
            chatbotMessage,
            editorWordCount
        })
    }

    prepareEditInfo = async () => {
        let { formData, editorState, variationsCount, leadUpdateVariationsCount, type, editorWordCount, formsList, selectedChatbotMSG, chatbotMessages } = this.state;

        //handle Input variations.
        if (type === "auto-reply" && Object.keys(formData).length > 0 && formData['Input'] !== undefined) {
            if (formData['Input'] !== "" && formData['Input'] !== null) {
                let input = parseJSON(formData['Input']);

                // variationsCount = 0;
                // this.variationIds = [];

                //update variation details.
                for (let i = 0; i < Object.keys(input).length; i++) {
                    formData['Variation' + i] = input[i];
                    this.variationIds.push(i);
                    variationsCount++;
                }
            }
        }

        if ((type === "auto-reply" || type === "quick-reply") && (formData['formname'] !== undefined && formData['formname'] !== '')) {
            if (formsList !== undefined) {
                formsList.map((val) => {
                    formData['formname'] = formData['formname'] !== null ? formData['formname'] : this.leadFormname;
                    if (formData['formname'] === val.value) {
                        this.setState({
                            selectedForm: val
                        })
                    }
                })
                this.getFieldsByFormname(formData['formname']);
            }
        }

        //decode Message info
        if (type !== "auto-reply") {
            if (Object.keys(formData).length > 0 && formData['Message'] !== undefined) {
                if (formData['Message'] !== "" && formData['Message'] !== null) {
                    formData['Message'] = decodeString(formData['Message'], true);
                    formData['Message'] = formData['Message'].trimEnd();
                    editorWordCount = formData['Message'].length;
                }
            }

            if (formData['Message'] !== undefined && formData['Message'] !== "") {
                let html = replaceStringTohtml(formData['Message']);
               // editorState = htmlToDraftBlocks(html);
            }
        }
        let updateLeadConfig = [];
        let isUpdateLead = false;
        if (type === "auto-reply" && Object.keys(formData).length > 0) {
            updateLeadConfig = formData['update_lead_info'] !== undefined && formData['update_lead_info'] !== null && formData['update_lead_info'] !== "" ? parseJSON(formData['update_lead_info']) : {};
            if (Object.keys(updateLeadConfig).length > 0) {
                isUpdateLead = true;

                //handle previous old data that doesn't contain array of lead update variations.
                if (updateLeadConfig['lead_fieldlist'] !== undefined) {
                    leadUpdateVariationsCount = 0;
                    this.leadUpdateVariationIds = [];
                    updateLeadConfig = [updateLeadConfig];
                    this.leadUpdateVariationIds.push(0);
                    leadUpdateVariationsCount++;
                } else {

                    //Reset count to 0 when values alreaddy available in db.
                    //If values not avilable on edit then count will be 1. So it will show 1 row by default.
                    if (Object.keys(updateLeadConfig).length > 0) {
                        leadUpdateVariationsCount = 0;
                        this.leadUpdateVariationIds = [];
                    }

                    //update the lead fields update variation details.
                    for (let i = 0; i < Object.keys(updateLeadConfig).length; i++) {
                        this.leadUpdateVariationIds.push(i);
                        leadUpdateVariationsCount++;
                    }
                }
            }
        }
        //update variables info in state if anything there.
        formData = getFieldValuefromComponent(formData, formData['Components']);
        let selectedTemplate = [];
        if (type === "waNotification" || type === "workflowAction") {
            selectedTemplate = formData['selectedTemplate'];
        }
        let recipientOptions = [];
        let waComponents = {};
        let components = [];
        if (type === "workflowAction" && selectedTemplate !== undefined) {
            recipientOptions = formData['recipients'];
            let { waTemplates } = this.props;
            let templateId = selectedTemplate.value;
            let template = waTemplates[templateId];
            components = parseJSON(decodeString(template['Components']));
            waComponents = getWAComponents(components);
        }

        //set default media value
        if (type !== 'auto-reply') {
            if (formData['MediaInfo'] !== undefined && formData['MediaInfo'] != null && formData['MediaInfo'] !== "") {
                formData['MediaInfo'] = parseJSON(formData['MediaInfo']);
            } else {
                if (formData['MediaInfo'] === undefined || formData['MediaInfo'] === "" || formData['MediaInfo'] == null) {
                    formData['MediaInfo'] = {};
                }
            }
        }

        this.setState({
            formData,
            editorState,
            variationsCount,
            leadUpdateVariationsCount,
            updateLeadConfig,
            isUpdateLead,
            editorWordCount,
            selectedTemplate,
            recipientOptions,
            waComponents, components
        });
    }

    handleChange = (e) => {
        let {  type, formData, chatbotMessage, } = this.state;
        let name = e.target.name;
        if (type === "auto-reply") {
            chatbotMessage[name] = e.target.value;
        }
        formData[name] = e.target.value;
        this.setState({ formData,chatbotMessage });
    }

    handleVariableChange = (selectedTemplate, objName) => {
        if (objName.includes('body_variable_field_') || objName.includes('header_variable')) {
            let { type, formData, chatbotMessage, previewData } = this.state;

            if (type === "auto-reply") {
                chatbotMessage[objName + "_selected"] = selectedTemplate;
            } else {
                formData[objName + "_selected"] = selectedTemplate;
            }
            previewData[objName] = selectedTemplate.value;
            previewData[objName + "_label"] = selectedTemplate.label;
            this.setState({ formData, chatbotMessage, previewData });
        }
    }

    addVariable = () => {
       
        let { type, formData, chatbotMessage, selectedForm } = this.state;

        if ((selectedForm.value !== undefined && type === 'auto-reply') || type !== 'auto-reply') {
            let count = 1;
            let variables = [];
            let Messsage = type === 'auto-reply' ? chatbotMessage['Message'] : formData['Message'];
            if (Messsage === undefined) {
                Messsage = '';
            }
            
            //Get current variables count in Message.
            if (Messsage !== '' && Messsage !== null) {
                variables = getWABodyVariables(Messsage);
                if (variables.length > 0) {
                    count = Math.max(...variables.map(Number)) + 1;
                }
            }
            this.setState({ 
                varaction: "insertText",
                variableCount: `{{${count}}}#$#${randomNumber()}` 
            });
         //   this.sendTextToEditor(`{{${count}}}`);
            // if (type === 'auto-reply') {
            //     chatbotMessage['Message'] = `${Messsage} {{${count}}}`;
            //     this.setState({ chatbotMessage });
            // } else {
            //     formData['Message'] = `${Messsage} {{${count}}}`;
            //     this.setState({ formData });
            // }
        }
    }

    // sendTextToEditor = (text) => {

    //     let { chatbotMessage } = this.state;

    //     this.setState({
    //         chatbotMessage: this.insertText(text, chatbotMessage)
    //     });
    // };

    // insertText = (text, editorState) => {
    //     const htmlContent = convertFromHTML(text, undefined);
    //     const currentContent = editorState.getCurrentContent(),
    //         currentSelection = editorState.getSelection();
    //     const htmlContentMap = BlockMapBuilder.createFromArray(
    //         htmlContent.contentBlocks
    //     );
    //     const newContent = Modifier.replaceWithFragment(
    //         currentContent,
    //         currentSelection,
    //         htmlContentMap
    //     );
    //     const newEditorState = EditorState.push(
    //         editorState,
    //         newContent,
    //         "insert-characters"
    //     );
    //     return EditorState.forceSelection(
    //         newEditorState,
    //         newContent.getSelectionAfter()
    //     );
    // };

    checkValidate = async (chatbotmsg) => {
        let valid = true
        let { chatbotMessages, formData } = this.state;
        let params = {
            "ENTITY": "WHATSAPPPROCESS",
            "OPERATION": "CHECKVALID_FOR_CHATBOT",
            "FORMINPUT": chatbotmsg,
            "FORMID": formData['table_66_id'],
            "isOtherApiReq": true,
        };

        let response = await requestApi.processServerRequest(params);
        if (response.issuccess) {
            let data = response.data;
            if (!data.isvalid) {
                valid = data.isvalid;
                let inputtype = data.inputtype;
                let inputvalue = data.inputvalue;
                if (inputtype === 'Name') {
                    showToast('This "' + inputvalue + '" is already exists ', 'top-right', 'error');
                } else {
                    showToast('This "' + inputvalue + '" is already exists ', 'top-right', 'error');
                }
            }
        }

        if (valid && !Object.keys(chatbotMessages).length > 0) {
            valid = false;
            showToast('Messages is Empty', 'top-right', 'error');
        }

        return valid;
    }

    submitForm = async (e) => {
        if (e !== undefined && e !== null && this.state.type !== "workflowAction") {
            e.preventDefault();
        }

        let {
            formData,
            type,
            variationsCount,
            leadUpdateVariationsCount,
            iaMessagesList,
            isUpdateLead,
            updateLeadConfig,
            editorWordCount,
            isIAMessage,
            defaultMessage,
            isResolveLead,
            selectedForm,
            editorState,
            chatbotMessageIds,
            recipientOptions
        } = this.state;
   //     this.onEditorStateChange(editorState);
        //Convert the emojis in message to unicode format.

        if (type === 'auto-reply') {
            let isValid = await this.checkValidate(formData);
            if (!isValid) {
                return;
            }
        }

        if (formData['Message'] == undefined) {
            if (this.messageRef !== undefined && this.messageRef != null) {
                if (this.messageRef.current !== undefined && this.messageRef.current != null) {
                    this.messageRef.current.focus();
                }
            }
        }
        if (formData['Message'] !== undefined && formData['Message'] !== '' && formData['Message'] !== null) {
            //formData['Message'] = emojiToUnicode(formData['Message']);
            formData['Message'] = trimSpaces(formData['Message']);
            formData['Message'] = normalizeTemplateVariables(formData['Message']);
        }

        if ((type === 'quick-reply') && (formData['Message'] === undefined || formData['Message'] === null || formData['Message'] === '\n' || formData['Message'] === '')) {
            this.setState({
                messageBoxRequired: true,
                editorErrorMsg: "Message is needed"
            })
            return;
        } else if (type === 'auto-reply' && +editorWordCount > this.editorMaxLength) {
            this.setState({
                messageBoxRequired: true,
                editorErrorMsg: "Value too long"
            })
            return;
        } else if ((type === 'inboxSettings' || type === 'optin_message' || type === 'optout_message') && !editorWordCount > 0) {
            this.setState({
                messageBoxRequired: true,
                editorErrorMsg: "Message is needed"
            })
            return;
        }


        if (type === `auto-reply`) {
            let input = [];
            let processedLeadUpdateConfig = [];

            if (variationsCount > 0) {
                let maxVariationId = (+this.variationIds[this.variationIds.length - 1]);
                for (let i = 0; i <= maxVariationId; i++) {
                    if (formData['Variation' + i] !== undefined) {
                        input.push(formData['Variation' + i]);
                    }
                }
            }

            if (leadUpdateVariationsCount > 0 && isUpdateLead) {
                let maxLeadUpdateVariationId = (+this.leadUpdateVariationIds[this.leadUpdateVariationIds.length - 1]);
                for (let i = 0; i <= maxLeadUpdateVariationId; i++) {
                    if (updateLeadConfig[i] !== undefined) {
                        processedLeadUpdateConfig.push(updateLeadConfig[i]);
                    }
                }
            }

            formData['convo_status'] = isResolveLead ? 1 : 0;
            formData['Input'] = JSON.stringify(input);
            formData['updateLead'] = processedLeadUpdateConfig;
            formData['chatbotMessageIds'] = chatbotMessageIds;
        }

        if (type === 'auto-reply' || type === 'quick-reply') {
            formData['formname'] = selectedForm.value !== undefined ? selectedForm.value : '';
        }
        if (type === "optout_message") {
            formData['Name'] = "Opt-out Response";
        } else if (type === "optin_message") {
            formData['Name'] = "Opt-in Response";
        }
        //formData['Name'] = type === "optout_message" ? "Opt-out Response" : "Opt-in Response";
        if ((type === "inboxSettings") && this.state.isIAMessage) {
            formData['iaMessageId'] = this.state.defaultMessage['value'];
        }
        if (type === "waNotification" || type === "workflowAction") {
            formData['waTemplate'] = this.state.selectedTemplate;
        }
        if (type === "workflowAction") {
            formData['recipients'] = this.state.recipientOptions;
        }
        if (type !== "auto-reply") {
            if (formData['MediaInfo'] !== undefined && formData['MediaInfo'] != null && formData['MediaInfo'] !== '' && Object.keys(formData['MediaInfo']).length > 0) {
                formData['MediaInfo'] = JSON.stringify(formData['MediaInfo']);
            } else {
                formData['MediaInfo'] = '';
            }

            //Reset media info when list interactive message is selected.
            //media messages are not supported in list interactive messages.
            if (isIAMessage && defaultMessage['type'] !== undefined && defaultMessage['type'] === "list") {
                formData['MediaInfo'] = '';
            }
        }
        this.props.onSave(formData);
    }

    addVariations = () => {
        let { variationsCount } = this.state;
        ++variationsCount;
        this.setState({ variationsCount });
    }

    addLeadUpdateVariations = () => {
        let { leadUpdateVariationsCount } = this.state;
        ++leadUpdateVariationsCount;
        this.setState({ leadUpdateVariationsCount });
    }

    removeVariations = (removedIndex, variationId) => {
        let { variationsCount, formData } = this.state;
        --variationsCount;
        delete formData['Variation' + variationId];
        delete this.variationIds.splice(removedIndex, 1);
        this.setState({ variationsCount, formData });
    }

    removeLeadUpdateVariations = (removedIndex, variationId) => {
        let { leadUpdateVariationsCount, updateLeadConfig } = this.state;
        --leadUpdateVariationsCount;
        delete updateLeadConfig[variationId];
        delete this.leadUpdateVariationIds.splice(removedIndex, 1);
        this.setState({ leadUpdateVariationsCount, updateLeadConfig });
    }

    onCheckBoxChange = async (e, name) => {
        if (name === "interactive_message") {
            this.setState({ isIAMessage: e.target.checked });
        } else if (name === "update_lead") {
            let { updateLeadConfig } = this.state;
            // if(!e.target.checked){
            //     updateLeadConfig = [];
            // }
            this.setState({
                isUpdateLead: e.target.checked, updateLeadConfig
            });
        } else if (name === "Resolve_Lead") {
            this.setState({ isResolveLead: e.target.checked });
        }
    }

    onMessageListChange = (selectedOption) => {
        this.setState((prevState) => {
            return {
                chatbotMessage: {
                    ...prevState.chatbotMessage,
                    IAMessage: selectedOption
                },
                defaultMessage: selectedOption
            };
        });
    };


    onFormFieldChange = async (selectedItem) => {
        if (selectedItem !== undefined && selectedItem.value !== undefined) {
            if (selectedItem !== this.state.selectedForm) {
                this.resetVariables();
                this.getFieldsByFormname(selectedItem.value);
                let selectedFormDetails = await this.getFormDetail(selectedItem.value);
                this.setState({
                    selectedForm: selectedItem,
                    updateLeadConfig: {},
                    leadUpdateVariationsCount: 1,
                    selectedFormDetails: selectedFormDetails
                })
            }
        }
    }

    getFormDetail = async (val) => {

        let getFormDetail = [];

        getFormDetail = await this.populateFormDetail(getFormDetail, val !== undefined ? val : '');

        return getFormDetail;
    }

    onLeadFieldChange = (selectedOption, name, variationId) => {
        let { updateLeadConfig } = this.state;

        if (updateLeadConfig[variationId] === undefined) {
            updateLeadConfig[variationId] = {};
        }

        if (name !== undefined && name == "lead_fieldlist") {
            // for update response same field maping
            for (let i = 0; i < Object.keys(updateLeadConfig).length; i++) {
                if (updateLeadConfig[i] !== undefined &&
                    updateLeadConfig[i]['lead_fieldlist'] !== undefined &&
                    updateLeadConfig[i]['lead_fieldlist']['value'] !== undefined &&
                    selectedOption['value'] !== undefined) {
                    if (updateLeadConfig[i]['lead_fieldlist']['value'] === selectedOption['value']) {
                        showToast("This Field is already selected. Please Change A Field !", "top-right", "warning");
                        return;
                    }

                }

            }
        }

        updateLeadConfig[variationId][name] = selectedOption;
        this.setState({
            updateLeadConfig
        })
    }

    onInputChange = (e, variationId) => {
        let name = e.target.name;
        let value = e.target.value;
        let { updateLeadConfig } = this.state;

        if (updateLeadConfig[variationId] === undefined) {
            updateLeadConfig[variationId] = {};
        }

        updateLeadConfig[variationId][name] = value;

        this.setState({
            updateLeadConfig
        })
    }

    handleTemplateChange = (selectedOption, templateName) => {
        let { waTemplates } = this.props;
        let templateId = selectedOption.value;
        let template = waTemplates[templateId];
        let components = parseJSON(decodeString(template['Components']));
        let waComponents = getWAComponents(components);
        let bodyComponent = waComponents['BODY'];
        let bodyText = bodyComponent['text'];
        let editorWordCount = bodyText.length;
        let html = replaceStringTohtml(bodyText);
       // let editorState = htmlToDraftBlocks(html);
        let variables = getWABodyVariables(bodyText);
        let { formData } = this.state;

        formData['Message'] = bodyText;
        this.setState({
            selectedTemplate: selectedOption,
         //   editorState: editorState,
            variationsCount: variables.length,
            variationIds: variables,
            editorWordCount,
            components, waComponents
        })
    }

    onRecipientsChange = (selectedValue) => {
        this.setState({
            recipientOptions: selectedValue
        })
    }

    onFileUpload = async (e) => {
        let { type, formData, chatbotMessage } = this.state;

        let mediaInfo = {};
        if (type === "auto-reply") {
            if (chatbotMessage['MediaInfo'] !== undefined && chatbotMessage['MediaInfo'] !== null && chatbotMessage['MediaInfo'] !== '') {
                //mediaInfo = chatbotMessage['MediaInfo'];
            }
            let { resetInput, formInputData } = await uploadFileIntoS3(e, mediaInfo);
            chatbotMessage['MediaInfo'] = formInputData;
            //Reset file input value. since something went wrong
            if (resetInput) {
                e.target.value = null;
            }
        } else {
            if (formData['MediaInfo'] !== undefined && formData['MediaInfo'] !== null && formData['MediaInfo'] !== '') {
                mediaInfo = formData['MediaInfo'];
            }
            let { resetInput, formInputData } = await uploadFileIntoS3(e, mediaInfo);
            formData['MediaInfo'] = formInputData;
            if (formInputData['mediaUrl'] !== undefined) {
                formData['mediaUrl'] = formInputData['mediaUrl']
            }
            if (formInputData['mediaType'] !== undefined) {
                formData['mediaType'] = formInputData['mediaType']
            }
            if (formInputData['fileName'] !== undefined) {
                formData['fileName'] = formInputData['fileName']
            }
            //Reset file input value. since something went wrong
            if (resetInput) {
                e.target.value = null;
            }
        }

        this.setState({
            formData: formData,
            chatbotMessage
        });

    }

    removeAttachment = () => {
        let { type, formData, chatbotMessage } = this.state;
        if (type === 'auto-reply') {
            chatbotMessage['MediaInfo'] = {};
            this.setState({ chatbotMessage });
        } else {
            formData['MediaInfo'] = {};
            this.setState({ formData });
        }
    }

    resetVariables = async (formInputData = this.state.formData) => {

        const filteredSelKeys = Object.keys(formInputData).filter(key => key.includes('body_variable_field_'));
        const filteredDFKeys = Object.keys(formInputData).filter(key => key.includes('body_df_value_field_'));

        let selected_value = 1;
        let df_value = 1;

        for (let i = 0; i < Object.keys(formInputData).length; i++) {
            if (filteredSelKeys[i] !== undefined && filteredSelKeys[i].includes('body_variable_field_')) {
                let k = 'body_variable_field_' + selected_value + "_selected";
                if (formInputData[k]) {
                    formInputData[k] = {};
                }
                selected_value++;
            }
            if (filteredDFKeys[i] !== undefined && filteredDFKeys[i].includes('body_df_value_field_')) {
                let k = 'body_df_value_field_' + df_value;
                if (formInputData[k]) {
                    formInputData[k] = '';
                }
                df_value++;
            }
        }
        this.setState({
            formData: formInputData
        });
    }

    getChatBotReplyMessage = async () => {
        let { formData } = this.state;
        let chatbotFormname = process.env.REACT_APP_QUICKREPLY_FORMNAME;
        this.setState({
            showLoader: true,
        })

        let params = {
            "ENTITY": "WHATSAPPPROCESS",
            "OPERATION": "GET_CHATBOT_MESSAGES",
            "isOtherApiReq": true,
            "FORMID": formData[chatbotFormname + '_id'],
        };

        let response = await requestApi.processServerRequest(params);
        if (response.issuccess) {
            let data = response.data;
            let orderMsg = [];
            for (let i = 0; i < data.length; i++) {
                orderMsg.push(
                    { 'label': 'Update Response - ' + data[i].name, 'value': 'UR-' + data[i].id, 'group': 'update_response' },
                );
            };
            for (let i = 0; i < data.length; i++) {
                orderMsg.push(
                    { 'label': 'Custom Value - ' + data[i].name, 'value': 'CV-' + data[i].id, 'group': 'custom_value' }
                );
            };
            this.setState({
                chatbotMessages: data,
                chatMessageCount: data.length === 0 ? 1 : data.length,
                messageOrder: orderMsg,
                showLoader: false,
                variableCount: ""
            });
        }
    }

    chatbotModalState = async (modalState, messageid = "") => {
        await this.prepareChatbotMessage(messageid);

        this.setState(
            {
                isChatbotModel: !this.state.isChatbotModel,
                selectedChatbotMSG: messageid,
            }
        )
    }

    incrementChatbotMSGCount = (e) => {
        let { chatMessageCount } = this.state;
        this.setState({
            chatMessageCount: chatMessageCount + 1,
        })
    }

    removeChatbotMSG = async (chatbotid, index) => {
        let { chatMessageCount, chatbotMessages, updateLeadConfig } = this.state;
        let confirm = await confirmBoxWithImage("DELETE", "You Want to Delete thi Data ? ");
        if (confirm) {
            let params = {
                "ENTITY": "WHATSAPPPROCESS",
                "OPERATION": "DELETE",
                "FORMNAME": this.chatMSGForm,
                "formid": chatbotid,
                "isTableForm": true,
            }

            let res = await requestApi.processServerRequest(params, "WebV2", "post");
            if (res.issuccess) {
                for (let i = 0; i < updateLeadConfig.length; i++) {
                    let chatid = "";
                    let updateLeadData = updateLeadConfig[i];
                    if (Object.keys(updateLeadData).length > 0) {
                        let messageorder = updateLeadData['message_order'];
                        let messageorderArr = messageorder['value'].split('-');
                        chatid = messageorderArr[1];
                    }
                    if (chatid === chatbotid) {
                        this.removeLeadUpdateVariations(i, chatbotid);
                    }
                }
                //this.getChatBotReplyMessage();

                chatbotMessages.splice(index, 1);
                this.setState({
                    chatbotMessages,
                    chatMessageCount: chatMessageCount - 1,
                })
            }
        }
    }

    getReplyTemplateContent = () => {

        let {
            leadFormDetail,
            waOptions
        } = this.props;

        let {
            formData,
            showEmojis,
            editorState,
            type,
            variationsCount,
            leadUpdateVariationsCount,
            updateLeadConfig,
            isUpdateLead,
            editorWordCount,
            editorErrorMsg,
            messageBoxRequired,
            isIAMessage,
            defaultMessage,
            selectedFormDetails,
            chatMessageCount,
            chatbotMessages,
            selectedForm,
            channelRecipientOptions,
            recipientOptions,
            selectedTemplate,
            variableCount,
            varaction
        } = this.state;
        let name = 'Name';
        if (type === 'auto-reply') {
            name = 'Input';
        }
        if (formData === undefined) {
            formData = {};
        }
        if (type === "optout_message" || type === "optin_message") {
            formData['Name'] = type === "optout_message" ? "Opt-out Response" : "Opt-in Response";
        }

        let variationList = [];
        let leadUpdateVariationList = [];

        for (let i = 0; i < variationsCount; i++) {
            let variationId = undefined;

            if (this.variationIds[i] !== undefined) {
                variationId = this.variationIds[i];
            } else {

                {/*
                 * create new variation id when id not found previously. This will be the last_max_value+1.
                 * If there is no variationId found then start from 0.
                */}
                if (this.variationIds.length > 0) {
                    variationId = (this.variationIds[this.variationIds.length - 1]) + 1;
                } else {
                    variationId = 0;
                }
                this.variationIds[i] = variationId;
            }

            variationList.push(
                <>
                    <div className={`input-variation`}>
                        <input
                            required={true}
                            value={formData['Variation' + variationId] !== undefined ? formData['Variation' + variationId] : ''}
                            onChange={(e) => { this.handleChange(e) }}
                            name={'Variation' + variationId}
                            type={'text'}
                            className={cx('form-control mt-1 mb-2', {
                                'autoreply-intenet': type !== 'quick-reply'
                            })}
                            autoComplete={'off'}
                            placeholder={`Input Variation ` + (i + 1)}
                        /*maxLength={20}*/
                        />
                        <span className={cx(`input-count hide`, {
                            'min-input-count': (formData['Variation' + variationId] !== undefined ? formData['Variation' + variationId].length : 0) < 10
                        })}>{`${(formData['Variation' + variationId] !== undefined ? formData['Variation' + variationId].length : 0)}/20`}</span>
                        <span className={`input-variation-remove ml-2`}>
                            <FontAwesomeIcon icon={faXmark} className={`mr-1`} onClick={() => this.removeVariations(i, variationId)} />
                        </span>
                    </div>
                </>
            )

        }

        let configOptions = [];
        if (type === 'auto-reply') {


            configOptions.push({
                value: "response", label: "Update Response"
            });
            configOptions.push({
                value: "custom_value", label: "Custom Value"
            })
        }

        for (let i = 0; i < leadUpdateVariationsCount; i++) {
            let leadUpdateVariationId = undefined;

            if (this.leadUpdateVariationIds[i] !== undefined) {
                leadUpdateVariationId = this.leadUpdateVariationIds[i];
            } else {

                //create new variation id when id not found previously. This will be the last_max_value+1.
                //If there is no variationId found then start from 0.
                if (this.leadUpdateVariationIds.length > 0) {
                    leadUpdateVariationId = (this.leadUpdateVariationIds[this.leadUpdateVariationIds.length - 1]) + 1;
                } else {
                    leadUpdateVariationId = 0;
                }
                this.leadUpdateVariationIds[i] = leadUpdateVariationId;
            }

            const showUpdateTypeClear = !(
                updateLeadConfig[leadUpdateVariationId] !== undefined &&
                updateLeadConfig[leadUpdateVariationId]['lead_option'] !== undefined &&
                updateLeadConfig[leadUpdateVariationId]['lead_option']['value'] === "custom_value"
            ) && (leadUpdateVariationsCount > 1);

            const showCustomValClear = (leadUpdateVariationsCount > 1);
            leadUpdateVariationList.push(
                <>
                    <Row className={'mt-2 mb-3 leadupdate-variation'}>
                        <Col md={'12'}>
                            <Row>
                                <Col md={'4'}>
                                    <Select
                                        id={`updateLead_Mapper${leadUpdateVariationId}`}
                                        name={`lead_fieldlist${leadUpdateVariationId}`}
                                        onChange={(e) => { this.onLeadFieldChange(e, "lead_fieldlist", leadUpdateVariationId) }}
                                        value={
                                            (updateLeadConfig[leadUpdateVariationId] !== undefined &&
                                                updateLeadConfig[leadUpdateVariationId]['lead_fieldlist'] !== undefined
                                            ) ? updateLeadConfig[leadUpdateVariationId]['lead_fieldlist'] : false
                                        }
                                        options={this.state.fields}
                                        className={`basic-multi-select `}
                                        classNamePrefix="wa-select"
                                        required={isUpdateLead && (updateLeadConfig[leadUpdateVariationId] === undefined || updateLeadConfig[leadUpdateVariationId]['lead_fieldlist'] === undefined || (updateLeadConfig[leadUpdateVariationId]['lead_fieldlist'] !== undefined && updateLeadConfig[leadUpdateVariationId]['lead_fieldlist'] === ''))}
                                        isDisabled={this.state.selectedForm == '' ? true : false}
                                    />
                                </Col>
                                <Col md={'4'}>
                                    <Row>
                                        <Col md={showUpdateTypeClear ? "11" : "12"}>
                                            <Select
                                                id={`updateLead_Mapper${leadUpdateVariationId}`}
                                                name={`message_order${leadUpdateVariationId}`}
                                                onChange={(e) => { this.onLeadFieldChange(e, "message_order", leadUpdateVariationId) }}
                                                value={
                                                    (updateLeadConfig[leadUpdateVariationId] !== undefined &&
                                                        updateLeadConfig[leadUpdateVariationId]['message_order'] !== undefined
                                                    ) ? updateLeadConfig[leadUpdateVariationId]['message_order'] : false
                                                }
                                                options={this.state.messageOrder}
                                                className={`basic-multi-select `}
                                                classNamePrefix="wa-select"
                                                required={isUpdateLead && (updateLeadConfig[leadUpdateVariationId] === undefined || updateLeadConfig[leadUpdateVariationId]['message_order'] === undefined || (updateLeadConfig[leadUpdateVariationId]['message_order'] !== undefined && updateLeadConfig[leadUpdateVariationId]['message_order'] === ''))}
                                                isDisabled={this.state.selectedForm == '' ? true : false}
                                            />
                                        </Col>
                                        {
                                            showUpdateTypeClear &&
                                            <Col md={'1 mt-1 pl-0'}>
                                                {
                                                    <span className={`input-variation-remove`}>
                                                        <FontAwesomeIcon icon={faXmark} className={`mr-1`} onClick={() => this.removeLeadUpdateVariations(i, leadUpdateVariationId)} />
                                                    </span>
                                                }
                                            </Col>
                                        }

                                    </Row>
                                </Col>
                                <Col md={'4'}>
                                    <div className={'d-flex'}>
                                        {updateLeadConfig[leadUpdateVariationId] !== undefined && updateLeadConfig[leadUpdateVariationId]['message_order'] !== undefined && updateLeadConfig[leadUpdateVariationId]['message_order']['group'] === "custom_value"
                                            &&
                                            <>
                                                <input
                                                    autoComplete={"off"}
                                                    placeholder={`Provide custom value`}
                                                    type={'text'}
                                                    value={
                                                        (
                                                            updateLeadConfig[leadUpdateVariationId] !== undefined &&
                                                            updateLeadConfig[leadUpdateVariationId]['custom_value'] !== undefined
                                                        ) ? updateLeadConfig[leadUpdateVariationId]['custom_value'] : ''
                                                    }
                                                    onChange={(e) =>
                                                        this.onInputChange(e, leadUpdateVariationId)
                                                    }
                                                    name={`custom_value`}
                                                    className={'form-control'}
                                                    required={isUpdateLead && (updateLeadConfig[leadUpdateVariationId] === undefined || updateLeadConfig[leadUpdateVariationId]['custom_value'] === undefined || updateLeadConfig[leadUpdateVariationId]['custom_value'] === '')}
                                                    isDisabled={this.state.selectedForm == '' ? true : false}
                                                />
                                                {
                                                    showCustomValClear &&
                                                    <span className={`input-variation-remove ml-2`}>
                                                        <FontAwesomeIcon icon={faXmark} className={`mr-1`} onClick={() => this.removeLeadUpdateVariations(i, leadUpdateVariationId)} />
                                                    </span>
                                                }
                                            </>
                                        }
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </>
            )
        }

        let mediaUrl = "";
        let chatbotEle = [];
        if (type === 'auto-reply') {

            for (let i = 0; i < chatMessageCount; i++) {
                let chatbotMessage = chatbotMessages[i];
                if (!chatbotMessage) {
                    chatbotMessage = {};
                }
                chatbotEle.push(
                    <div>
                        <ChatbotList
                            chatbotMessage={chatbotMessage}
                            number={i}
                            selectedFormName={selectedForm['value']}
                            isAddEnabled={chatMessageCount === i + 1}
                            isDelEnabled={chatMessageCount !== 1}
                            chatbotModalState={this.chatbotModalState}
                            incrementChatbotMSGCount={this.incrementChatbotMSGCount}
                            removeChatbotMSG={this.removeChatbotMSG}
                        />
                    </div>
                );
            };
        };

        if (formData['MediaInfo'] !== undefined && formData['MediaInfo'] && formData['MediaInfo']['mediaUrl'] !== undefined && formData['MediaInfo']['mediaUrl'] !== null) {
            mediaUrl = formData['MediaInfo']['mediaUrl'];
        }
        let { control, formState: { errors } } = this.props.useForm;

        return (
            <div className={`${type === 'auto-reply' ? 'mt-3 vertical-timeline-without-image' : ''}`}>

                {/*Name for auto-reply */}
                {
                    type === "auto-reply" &&
                    <div className={`automation-section row`}>
                        <div className="group-header group-header-flex">
                            <div className="automation-stepnumber">1</div>
                            <span> Provide a Name</span>
                        </div>
                        <div className={`margin-left-3 col-md-10`}>
                            <label className="automation-lbl form-label"> Name </label>
                            <input
                                required={type === 'auto-reply' ? true : false}
                                value={formData['Title'] !== undefined ? formData['Title'] : ''}
                                onChange={(e) => { this.handleChange(e) }}
                                name={'Title'}
                                type={'text'}
                                disabled={type === "optout_message" || type === "optin_message"}
                                className={cx('form-control', { 'hide': type === 'quick-reply' })}
                                autoComplete={'off'}
                            />
                        </div>
                    </div>
                }

                {/*Name for workflow action */}
                {
                    type === "workflowAction" &&
                    <Fragment>
                        <div className={`mb-3`}>
                            <label className="automation-lbl form-label"> Name </label>
                            <Controller
                                name="action_name"
                                control={control}
                                rules={{ required: formData.action_name === undefined ? "Please provide Name" : "" }}
                                render={({ field }) => {
                                    return (
                                        <input
                                            {...field}
                                            value={formData['action_name'] !== undefined ? formData['action_name'] : ''}
                                            onChange={
                                                (e) => {
                                                    this.handleChange(e)
                                                    field.onChange(e)
                                                }
                                            }
                                            name={'action_name'}
                                            type={'text'}
                                            className={`form-control ${errors.action_name ? 'is-invalid' : ''}`}
                                            autoComplete={'off'}
                                        />
                                    );
                                }}
                            />
                            {errors.action_name && <em className={`error invalid-feedback`}>{errors.action_name.message}</em>}
                        </div>
                        <div className='mb-3'>
                            <label className="automation-lbl form-label"> Recipients </label>
                            <Controller
                                name="recipents"
                                control={control}
                                rules={{ required: Object.keys(recipientOptions).length === 0 ? "Please choose recipients" : "" }}
                                render={({ field }) => {
                                    return (
                                        <Select
                                            {...field}
                                            isMulti
                                            placeholder={'---Choose One---'}
                                            menuPlacement={"auto"}
                                            menuPosition={'fixed'}
                                            name={"recipents"}
                                            id={"recipents"}
                                            className={`basic-multi-select ${errors.recipents ? 'is-invalid' : ''}`}
                                            classNamePrefix="wa-select"
                                            value={recipientOptions}
                                            onChange={e => {
                                                this.onRecipientsChange(e, 'recipents');
                                                field.onChange(e)
                                            }}
                                            options={channelRecipientOptions}
                                        />
                                    );
                                }}
                            />
                            {errors.recipents && <em className={`error invalid-feedback`}>{errors.recipents.message}</em>}
                        </div>
                        <div className='mb-3'>
                            <label className="automation-lbl form-label"> Additional Recipients</label>
                            <input
                                type="text"
                                name="extra_recipients"
                                id="extra_recipients"
                                value={formData['extra_recipients'] !== undefined ? formData['extra_recipients'] : ''}
                                autoComplete={"off"}
                                onChange={(e) => {
                                    this.handleChange(e)
                                }}
                                placeholder='Use commas to separate recipients'
                                className={`form-control`}
                            />
                        </div>
                    </Fragment>
                }

                {/*WhatsApp Template*/}
                {
                    type === "waNotification" &&
                    <div className={`mb-3`}>
                        <label className={''} htmlFor={'templateName'}>{'Template Name'}</label>
                        <Select
                            required={true}
                            menuPlacement={"auto"}
                            menuPosition={'fixed'}
                            name="templates"
                            id="templates"
                            value={this.state.selectedTemplate}
                            onChange={e => {
                                this.handleTemplateChange(e, 'wa_template');

                            }}
                            options={waOptions}
                            className={`basic-multi-select `}
                            classNamePrefix="wa-select"
                        />
                    </div>
                }



                {/*Name for forms other than auto-reply */}
                {
                    type !== "auto-reply" && type !== "waNotification" && type !== "workflowAction" &&
                    <div className={`mb-3 ${type === "optout_message" || type === "optin_message" || type === "inboxSettings" ? 'hide' : ''}`}>
                        <label className={type === 'auto-reply' ? 'optmanagement-h4 fw-bolder' : ''} htmlFor="quickreply_name">{name}</label>
                        <div className={cx('ft-max-width automation-lblform-label pb-4', { 'hide': type !== "auto-reply" })}>Please note that the bot replies will only be triggered when the customer's input matches the specified input or its variations exactly. The bot replies work based on exact match conditions.</div>
                        <input
                            required={true}
                            value={formData['Name'] !== undefined ? formData['Name'] : ''}
                            onChange={(e) => { this.handleChange(e) }}
                            name={'Name'}
                            type={'text'}
                            disabled={type === "optout_message" || type === "optin_message"}
                            className={cx('form-control', { 'autoreply-intenet': type !== 'quick-reply' })}
                            autoComplete={'off'}
                        />
                    </div>
                }

                {/* Quick Reply Multiform */}
                {
                    type === "quick-reply" &&
                    <div className={`mb-3`} onClick={this.messageBoxzindex = false}>
                        <label htmlFor="quickreply_name"> Choose a Module </label>
                        <Select
                            name={'selected_form'}
                            onChange={(e) => { this.onFormFieldChange(e) }}
                            value={this.state.selectedForm}
                            options={this.state.formsList !== undefined ? this.state.formsList : ""}
                            className={'basic-multi-select z-10'}
                            classNamePrefix="wa-select"
                            required={true}
                        />
                    </div>
                }

                {/*Input for auto-reply */}

                {
                    type === "auto-reply" &&
                    <div className={`automation-section row`}>
                        <div className="group-header group-header-flex">
                            <div className="automation-stepnumber">2</div>
                            <span> Provide Customer Input</span>
                        </div>
                        <div className={`margin-left-3 col-md-10`}>
                            <div className='pb-2 ln-1'>To create a bot reply, you will need to specify the customer input that will trigger the response. You can enter the primary input and up to five variations of it. When a customer types in any of the specified inputs, the auto response will be triggered.</div>
                            <div>Please note that the bot replies will only be triggered when the customer's input matches the specified input or its variations exactly. </div>
                            <label className="automation-lbl form-label" >{name}</label>
                            <span className={`input-variation`}>
                                <input
                                    required={true}
                                    value={formData['Name'] !== undefined ? formData['Name'] : ''}
                                    onChange={(e) => { this.handleChange(e) }}
                                    name={'Name'}
                                    type={'text'}
                                    disabled={type === "optout_message" || type === "optin_message"}
                                    className={cx('form-control', { 'autoreply-intenet': type !== 'quick-reply' })}
                                    autoComplete={'off'}
                                /*maxLength={20}*/
                                />
                                <span className={cx(`input-count hide`, {
                                    'min-input-count': (formData['Name'] !== undefined ? formData['Name'].length : 0) < 10
                                })}>{`${(formData['Name'] !== undefined ? formData['Name'].length : 0)}/20`}</span>
                            </span>
                        </div>
                        <div className={`margin-left-3 col-md-10`}>
                            <div className={`input-variation-wrapper space-name-input`}>
                                {
                                    variationList &&
                                    variationList.length > 0 &&
                                    variationList.map((variation) => {
                                        return variation;
                                    })
                                }
                            </div>
                            <div className={cx(`input-variation-wrapper`, {
                                'hide': variationsCount >= 5
                            })}>
                                <div className={`add-autoreply-intent mt-3`} onClick={this.addVariations} >
                                    <FontAwesomeIcon icon={faPlus} className={`mr-1`} />
                                    Add another variation
                                </div><p className={"white-space"}></p>
                            </div>
                        </div>
                    </div>
                }

                {/* Selected Form*/}
                {
                    type === 'auto-reply' &&
                    <div className={`automation-section row mt-2`}>
                        <div className="group-header group-header-flex">
                            <div className="automation-stepnumber">3</div>
                            <span>Choose a Module</span>
                        </div>
                        <div className={`margin-left-3 col-md-10`}>
                            <div className={'pt-2'}>
                                <div>
                                    <Col md={'12'}>
                                        <Row>
                                            <Col md={'8'}>
                                                <Select
                                                    name={'selected_form'}
                                                    onChange={(e) => { this.onFormFieldChange(e) }}
                                                    value={this.state.selectedForm}
                                                    options={this.state.formsList !== undefined ? this.state.formsList : ""}
                                                    className={'basic-multi-select z-10'}
                                                    classNamePrefix="wa-select"
                                                />
                                            </Col>
                                        </Row>
                                    </Col>
                                </div>
                            </div>
                        </div>
                    </div>
                }
                {type === 'auto-reply' &&
                    <Row className={'automation-section'}>
                        <div className={'group-header mt-3 group-header-flex'}>
                            <div className={'automation-stepnumber'}>
                                4
                            </div>
                            <span> Add your messages</span>
                        </div>
                        <Col md={"10"}>
                            <div className={'campaigns-content'}>
                                <div className={'d-flex-alone'}>
                                    <div className={'align-center col-md-10'}>
                                        <div className={'d-flex-alone col-md-12'}>
                                            <div className={cx('col-md-9 display-align-center')}>
                                                <div className={cx('pl-1')}>
                                                    Name
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={'col-md-2 campaign-action-buttons justify-content-center'}>
                                        <div className={'form-group'}>
                                            <div className={'form-row-action-buttons chatbot-action-header'}>
                                                Actions
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {chatbotEle}
                        </Col>
                    </Row>
                }

                {
                    type !== "auto-reply" && type !== "workflowAction" &&
                    <div onClick={(e) => { this.messageBoxzindex = true }}>
                        <label className={cx(type === 'auto-reply' ? 'optmanagement-h4 fw-bolder' : 'optmanagement')} htmlFor="quickreply_name">{type === 'auto-reply' ? 'Auto Reply Message' : 'Message'}</label>
                        <div className={cx('optmanagement pb-4', { 'hide': type !== "auto-reply" })}>
                            Here, you can configure the bot reply message that will be triggered when a customer sends the specified input or one of its variations in the chat.
                        </div>

                        <CKEditorComponent 
                            isMentionsNeeded={false} 
                            isNew={true} 
                            content={formData['Message']} 
                            //  mentionItems={fieldsOption} 
                            onEditorChange={this.onCKEditorChanges} 
                            type={type}
                            addVariable={variableCount}
                            action={varaction}
                            />
                        <em className={cx(`error invalid-feedback editor-error-msg`, { 'hide': !messageBoxRequired })}>{editorErrorMsg}</em>
                        {type !== "waNotification" && type !== "workflowAction" && <div className={`reply-input-beautifiers`}>
                            <div className={`reply-input-variable`}>
                                <FontAwesomeIcon icon={faPlus} />
                                <p onClick={this.addVariable} className={`reply-input-variable-text`}>Add variable</p>
                            </div>
                            <div className={`reply-input-variable hide`}>
                                <Icon id="strikethrough" color={"#919191"} onClick={this.onStrikeClick} />
                            </div>
                            <div className={`reply-input-variable hide`}>
                                <Icon id="italic" color={"#919191"} onClick={this.onItalicClick} />
                            </div>
                            <div className={`reply-input-variable hide`}>
                                <Icon id="bold" color={"#919191"} onClick={this.onBoldClick} />
                            </div>
                            <div className={`reply-input-variable`}>
                                <Icon id="smiley" color={"#919191"} onClick={this.toggleEmoji} />
                                <div className={`quickreply-emoji-wrapper`}>
                                    <div className={cx(`wp-emoji-picker`, {
                                        "quick-reply-emoji-align": type !== "auto-reply",
                                        "auto-reply-emoji-align": type === "auto-reply",
                                        "hide": !showEmojis,
                                    })}>
                                        {
                                            showEmojis &&
                                            <Picker
                                                data={data}
                                                onEmojiSelect={this.addEmoji}
                                                emojiButtonSize={36}
                                                emojiSize={20}
                                                previewPosition={`none`}
                                            />
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                        }
                    </div>
                }

                {/* Variable fields configuration */}
                <div className={`${type === "auto-reply" ? `automation-section row` : ``} ${type === "auto-reply" ? "hide" : ""}`}>
                    <div className={type === "auto-reply" ? `margin-left-3 col-md-10` : ``}>
                        <Row className={cx({ 'hide': type !== "workflowAction" && (formData['Message'] === undefined || formData['Message'] === '' || formData['Message'] === null) })}>
                            <div className={'d-grid'}>
                                {
                                    formData['Message'] !== undefined && formData['Message'] !== '' && type !== "workflowAction" &&
                                    <BodyComponent
                                        source={`quickreply`}
                                        values={formData}
                                        formDetail={selectedFormDetails}
                                        handleChange={this.handleVariableChange}
                                        handleInputChange={this.handleChange}
                                        component={formData['Components'] !== '' && formData['Components'] !== null ? formData['Components'] : ''}
                                    />
                                }
                                {
                                    type === "workflowAction" &&
                                    <WhatsappComponent
                                        form={this.props.useForm}
                                        errors={errors}
                                        waComponents={this.state.waComponents}
                                        handleInputChange={this.handleChange}
                                        onFileUpload={this.onFileUpload}
                                        handleTemplateChange={this.handleVariableChange}
                                        previewData={this.state.previewData}
                                        leadFormDetail={selectedFormDetails}
                                        formData={this.state.formData}
                                    />
                                }
                            </div>
                        </Row>
                    </div>
                </div>

                {/* interactive message checkbox for inbox settings*/}
                <div className={cx('mt-2', { 'hide': type !== 'inboxSettings' })}>
                    <div className={'flex-center-v'}>
                        <Input
                            type="checkbox"
                            onChange={(e) => {
                                this.onCheckBoxChange(e, "interactive_message")
                            }}
                            checked={this.state.isIAMessage}
                            value="interactive_message"
                            className={'form-control mt-0'}
                            name="ia_message"
                        />
                        <span className={'ml-1'}> Enable list messages or reply buttons with this message</span>
                    </div>
                    {this.state.isIAMessage && <div className={"mt-2 pb-4"}>
                        <label className={'group-header-lbl mb-1'} htmlFor="messageType">Choose a list messages or reply button</label>
                        <Select
                            isClearable={true}
                            name="messageType"
                            className={"message-type"}
                            classNamePrefix="wa-select"
                            id={`message_type`}
                            value={this.state.defaultMessage}
                            onChange={(e) => (
                                this.onMessageListChange(e)
                            )}
                            options={this.state.iaMessagesList}
                        />
                    </div>}
                </div>

                {/* interactive message checkbox for auto-reply */}
                {/* {
                    type === "auto-reply" &&
                    <div className={`automation-section row`}>
                        <div className="group-header group-header-flex">
                            <div className="automation-stepnumber">5</div>
                            <span> Enable List Messages/ Reply Buttons</span>
                        </div>
                        <div className={`margin-left-3 col-md-10`}>
                            <div className={'flex-center-v'}>
                                <Input
                                    type="checkbox"
                                    onChange={(e)=> {
                                        this.onCheckBoxChange(e, "interactive_message")
                                    }}
                                    checked={this.state.isIAMessage}
                                    value="interactive_message"
                                    className={'form-control mt-0'}
                                    name="ia_message"
                                />
                                <span className={'ml-1'}> Enable list messages or reply buttons with this reply message</span>
                            </div>
                            {this.state.isIAMessage && <div className={"mt-2 pb-4"}>
                                <label className={'group-header-lbl mb-2'} htmlFor="messageType">Choose a list messages or reply button</label>
                                <Select
                                    isClearable={false}
                                    name="messageType"
                                    className={"message-type"}
                                    classNamePrefix="wa-select"
                                    id={`message_type`}
                                    value={this.state.defaultMessage}
                                    onChange={(e) => (
                                        this.onMessageListChange(e)
                                    )}
                                    options={this.state.iaMessagesList}
                                    required={true}
                                />
                            </div> }
                        </div>
                    </div>
                } */}

                {
                    type === 'auto-reply' &&
                    <div className={`automation-section row mt-2`}>
                        <div className="group-header group-header-flex">
                            <div className="automation-stepnumber">5</div>
                            <span>Update Response</span>
                        </div>
                        <div className={`margin-left-3 col-md-10`}>
                            <div className={'pt-2'}>
                                <div className={'flex-center-v'}>
                                    <Input type="checkbox" onChange={(e) => { this.onCheckBoxChange(e, "update_lead") }} checked={this.state.isUpdateLead} value="update_lead" className={'form-control mt-0'} name="update_lead" />
                                    <span className={'ml-1'}> Update Customer Response</span>
                                </div>
                                {
                                    isUpdateLead &&
                                    <div>
                                        {
                                            leadUpdateVariationList &&
                                            leadUpdateVariationList.length > 0 &&
                                            leadUpdateVariationList.map((variation) => {
                                                return variation;
                                            })
                                        }
                                        <div className={cx(`input-variation-wrapper`, {
                                            'hide': leadUpdateVariationsCount >= 10
                                        })}>
                                            <div className={`add-autoreply-intent mt-3`} onClick={this.addLeadUpdateVariations} >
                                                <FontAwesomeIcon icon={faPlus} className={`mr-1`} />
                                                Update another field
                                            </div><p className={"white-space"}></p>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                }
                {
                    type === "auto-reply" &&
                    <div className={`automation-section row`}>
                        <div className="group-header group-header-flex">
                            <div className="automation-stepnumber">6</div>
                            <span> Auto Resolve the Conversation</span>
                        </div>
                        <div className={`margin-left-3 col-md-10`}>
                            <div className={'flex-center-v'}>
                                <Input
                                    type="checkbox"
                                    onChange={(e) => {
                                        this.onCheckBoxChange(e, "Resolve_Lead")
                                    }}
                                    checked={this.state.isResolveLead}
                                    value="Resolve_Lead"
                                    className={'form-control mt-0'}
                                    name="Resolve_Lead"
                                />
                                <span className={'ml-1'}> Resolve the conversation, after sending the auto reply message</span>
                            </div>
                        </div>
                    </div>
                }
                <div>
                    <Modal isOpen={this.state.isChatbotModel} size={type === 'auto-reply' || type === 'waNotification' || type === 'workflowAction' ? 'lg' : 'md'} >
                        <ModalHeader toggle={this.cancelChatbotMSG}>
                            {"Chat Bot"}
                        </ModalHeader>
                        <ModalBody>
                            {this.getChatbotMSGContent()}
                        </ModalBody>
                        <ModalFooter>
                            <Button className={`le-button lePrimaryBtn br-4`} color="primary" type={'submit'} onClick={e => { this.saveChatbotMessage(e) }}>
                                {"Save"}
                            </Button>
                        </ModalFooter>
                    </Modal>
                </div>
            </div>
        );
    }
     onCKEditorChanges = async (e, editors) => {
        let { formData, editorWordCount, messageBoxRequired, editorErrorMsg, type, variablesIndexNo, chatbotMessage,variableCount } = this.state;
       const plainText = editors
       .getData()
       .replace(/<[^>]*>/g, '')        // Remove HTML tags
       .replace(/&nbsp;/g, ' ');     // Replace &nbsp; with a regular space
       const characterCount = Array.from(plainText).length;
       const editorData = editors.getData();
        if (type === 'auto-reply') {
            if (chatbotMessage['Message'] === undefined) {
                chatbotMessage['Message'] = '';
            }
            chatbotMessage['Message'] = editorData;
            editorWordCount = characterCount; //chatbotMessage['Message'].length;
        }

        if (formData['Message'] === undefined) {
            formData['Message'] = '';
        }
        if (type !== 'auto-reply') {
           // formData = removeUnnecessoryVariable(formData, variablesIndexNo);
            //convert html to string.
           // formData['Message'] = draftToHtml(convertToRaw(editorState.getCurrentContent()));
          //  formData['Message'] = replaceHtmlToString(formData['Message']);
          //  formData['Message'] = formData['Message'].trimEnd();
            formData['Message'] = editorData;
            editorWordCount = characterCount; //formData['Message'].length;
        }

        if (type === 'auto-reply') {
            if (editorWordCount > this.editorMaxLength) {
                messageBoxRequired = true;
                editorErrorMsg = "Value too long";
            } else {
                messageBoxRequired = false;
                editorErrorMsg = "";
            }
        }

        if (type === 'inboxSettings' || type === 'optin_message' || type === 'optout_message') {
            if (!editorWordCount > 0) {
                messageBoxRequired = true;
                editorErrorMsg = "Message is needed";
            } else {
                messageBoxRequired = false;
                editorErrorMsg = "";
            }
        }

        this.setState({
            formData, editorWordCount, messageBoxRequired, editorErrorMsg, chatbotMessage,variableCount
        });
    }

    getChatbotMSGContent = () => {
        let { type, editorState, showEmojis, editorWordCount, editorErrorMsg, defaultMessage, isIAMessage, formData, selectedFormDetails, chatbotMessage, messageBoxRequired,selectedChatbotMSG,variableCount,varaction } = this.state;
        let mediaUrl = "";
        if (chatbotMessage['MediaInfo'] !== undefined) {
            let mediaInfo = chatbotMessage['MediaInfo'];
            mediaInfo = parseJSON(mediaInfo);
            mediaUrl = mediaInfo['mediaUrl'];
        }
        const attachmentBtnLabel = "Upload File";
        const documentFilters = ".jpg,.png,.jpeg,.txt,.pdf,.csv,.docx,.html,.xlsx,.mp4,.3gp";
        return (
            <>
                {
                    type === "auto-reply" &&
                    <div className={`automation-section row pb-0`}>
                        <div className={`margin-left-3 col-md-10`}
                            tabIndex={0}
                            ref={this.messageRef}>
                            <label className=''>Name</label>
                            <Input
                                type='text'
                                name='name'
                                value={chatbotMessage['name']}
                                onChange={e => this.handleModalChange(e)}
                                autoComplete={"off"}
                                placeholder='Name'
                            />
                            <div className='pb-2'>Here, you can configure the bot reply message that will be triggered when a customer sends the specified input or one of its variations in the chat.</div>
                            <label className="automation-lbl form-label" >Message content</label>
                            {/* <Editor
                                editorState={editorState}
                                onEditorStateChange={this.onEditorStateChange}
                                editorClassName={cx(`quickreply-editor`, {
                                    "quickreply-editorpadding": type === "auto-reply" || type === "inboxSettings"
                                })}
                                wrapperClassName={cx(`quickreply-editor-wrapper`, {
                                    "editor-error": messageBoxRequired
                                })}
                                toolbarClassName={`toolbarClassName`}
                                toolbarHidden
                                disabled={chatbotMessage['name'] !== ""}
                            /> */}
                              <CKEditorComponent 
                                isMentionsNeeded={false} 
                                isNew={true} 
                                content={chatbotMessage['Message']} 
                                mentionItems={""} 
                                onEditorChange={this.onCKEditorChanges} 
                                type={type}
                                addVariable={variableCount}
                                action={varaction}
                            />
                            <div className="editior-word-counter">{`${editorWordCount}`} / 1024</div>
                            <em className={cx(`error invalid-feedback editor-error-msg`, { 'hide': !messageBoxRequired })}>{editorErrorMsg}</em>
                            <div className={`reply-input-beautifiers`}>
                                <div className={cx(`reply-input-variable`, { 'disabled-area': this.state.selectedForm == '' })}>
                                    <FontAwesomeIcon icon={faPlus} />
                                    <p onClick={this.addVariable} className={cx(`reply-input-variable-text`, { 'disabled-area': this.state.selectedForm == '' })}>Add variable</p>
                                </div>
                                <div className={`reply-input-variable hide`}>
                                    <Icon id="strikethrough" color={"#919191"} onClick={this.onStrikeClick} />
                                </div>
                                <div className={`reply-input-variable hide`}>
                                    <Icon id="italic" color={"#919191"} onClick={this.onItalicClick} />
                                </div>
                                <div className={`reply-input-variable hide`}>
                                    <Icon id="bold" color={"#919191"} onClick={this.onBoldClick} />
                                </div>
                                <div className={`reply-input-variable`}>
                                    <Icon id="smiley" color={"#919191"} onClick={this.toggleEmoji} />
                                    <div className={`quickreply-emoji-wrapper`}>
                                        <div className={cx(`wp-emoji-picker`, {
                                            "quick-reply-emoji-align": type === "quick-reply" || type === "inboxSettings" || type === "waNotification" || type === "workflowAction",
                                            "auto-reply-emoji-align": type === "auto-reply",
                                            "hide": !showEmojis,
                                        })}>
                                            {
                                                showEmojis &&
                                                <Picker
                                                    data={data}
                                                    onEmojiSelect={this.addEmoji}
                                                    emojiButtonSize={36}
                                                    emojiSize={20}
                                                    previewPosition={`none`}
                                                />
                                            }
                                        </div>
                                    </div>
                                </div>
                                <div className={cx(`reply-input-attachment`, {
                                    'hide': isIAMessage && defaultMessage && defaultMessage['type'] !== undefined && defaultMessage['type'] !== null && defaultMessage['type'] === 'list'
                                })}>
                                    <CratioFileUploader
                                        mediaUrl={mediaUrl}
                                        errors={''}
                                        btnLbl={attachmentBtnLabel}
                                        handleFile={this.onFileUpload}
                                        filesAccept={documentFilters}
                                    />
                                    <span className={cx(`ml-2 mt-2`, {
                                        'hide': mediaUrl === ""
                                    })} onClick={this.removeAttachment}>
                                        <FontAwesomeIcon icon={faXmark} className={`mr-1`} />
                                    </span>
                                </div>
                            </div>
                        </div>
                        {
                            <div className={`${type === "auto-reply" ? `automation-section row` : ``}`}>
                                <div className={type === "auto-reply" ? `margin-left-3 col-md-10` : ``}>
                                    <Row className={cx({ 'hide': chatbotMessage['Message'] === undefined || chatbotMessage['Message'] === '' || chatbotMessage['Message'] === null })}>
                                        <div className={'d-grid'}>
                                            {
                                                chatbotMessage['Message'] !== undefined && chatbotMessage['Message'] !== '' &&
                                                <BodyComponent
                                                    source={`auto-reply`}
                                                    values={chatbotMessage}
                                                    formDetail={selectedFormDetails}
                                                    handleChange={this.handleVariableChange}
                                                    handleInputChange={this.handleChange}
                                                    component={chatbotMessage['components'] !== '' && chatbotMessage['components'] !== null ? chatbotMessage['components'] : ''}
                                                />
                                            }
                                        </div>
                                    </Row>
                                </div>
                            </div>
                        }
                        <div className={`automation-section row chatbot-iamsg-model`}>
                            <div className={`margin-left-3 col-md-10`}>
                                <div className={'flex-center-v'}>
                                    <Input
                                        type="checkbox"
                                        onChange={(e) => {
                                            this.onCheckBoxChange(e, "interactive_message")
                                        }}
                                        checked={isIAMessage}
                                        value="interactive_message"
                                        className={'form-control mt-0'}
                                        name="ia_message"
                                    />
                                    <span className={'ml-1'}> Enable list messages or reply buttons with this reply message</span>
                                </div>
                                {isIAMessage && <div className={"mt-2 pb-4"}>
                                    <label className={'group-header-lbl mb-2'} htmlFor="messageType">Choose a list messages or reply button</label>
                                    <Select
                                        isClearable={false}
                                        name="messageType"
                                        className={"message-type"}
                                        classNamePrefix="wa-select"
                                        id={`message_type`}
                                        value={this.state.defaultMessage}
                                        onChange={(e) => (
                                            this.onMessageListChange(e)
                                        )}
                                        options={this.state.iaMessagesList}
                                        required={true}
                                        menuPlacement={"auto"}
                                        menuPosition={'fixed'}
                                    />
                                </div>}
                            </div>
                        </div>
                    </div>
                }
            </>
        )
    }

    handleModalChange = (e) => {
        const name = e.target.value;
        let { chatbotMessage } = this.state;
              chatbotMessage['name'] = name;
        this.setState({
          chatbotMessage
      })
    };

    triggerSubmit = (e) => {
        this.submitRef.current.click();
    }

    cancelChatbotMSG = () => {
        this.setState({
            messageBoxRequired: false,
            editorErrorMsg: "",
            isChatbotModel: false,
              variableCount: "",
            varaction: ""
        })
    }
    prepareFormVaribles = async (formDetail) => {
        let selectedfields = await getFieldsByFormname(selectedformname.value, "crm_template_operation");
            //let orgfields = await getFieldsByFormname(orgFormName, "organization");
            //const mergedArray = [...selectedfields, ...orgfields.filter(obj2 => !selectedfields.some(obj1 => obj1.value === obj2.value))];
            setFieldsOption(selectedfields);
        let fieldDetails = formDetail !== undefined && formDetail[1] !== undefined ? formDetail[1] : [];
        let fieldsOptions = [];
        let skipFields = [
            `${this.formname}_id`,
            'Lead_ID',
            'wsapp_recent_activity',
            'wsapp_convo_status',
            'wsapp_unread_count',
            'wsapp_optin_status',
            'wsapp_recent_msg_id',
            'wsapp_enabled',
            'wsapp_blocked',
            'wsapp_opt',
            'wsapp_last_delivered',
            'wsapp_last_read',
            'wsapp_last_replied',
            'wsapp_last_sent_msg_id',
            'wsapp_last_sent_msg_id',
            'wsapp_completed_campaign'
        ];

        fieldDetails && fieldDetails.map((field) => {
            let fieldName = field[2];
            let fieldLabel = field[3];
            let fieldType = field[4];
            let isConfigHide = parseInt(field[10]);
            let isViewHide = parseInt(field[11]);
            if(!isConfigHide && !isViewHide){
                if(fieldType !== 'subtable' && fieldType !== 'reference_entityid' && fieldType !== "reference_group" && fieldType !== "form_history") {
                    if(!skipFields.includes(fieldName)){
                        if(fieldLabel !== undefined && fieldName !== undefined){
                            fieldsOptions.push({
                                value: fieldName, label: fieldLabel, fieldType : fieldType
                            });
                        }
                    }
                }
            }
        });
        return fieldsOptions;
    }
    saveChatbotMessage = async (e) => {
        e.preventDefault();

        let { type, formData, chatbotMessage, selectedChatbotMSG, chatbotMessages, updateLeadConfig } = this.state;
        
        if (type === 'auto-reply' && (chatbotMessage['Message'] === undefined || chatbotMessage['Message'] === null || chatbotMessage['Message'] === '\n' || chatbotMessage['Message'] === '')) {
            this.setState({
                messageBoxRequired: true,
                editorErrorMsg: "Message is needed"
            })
            return;
        };
        if (chatbotMessage['Message'] !== undefined && chatbotMessage['Message'] !== "") {
            chatbotMessage['Message'] = trimSpaces(chatbotMessage['Message']);
        }
        if (chatbotMessage['name'] === undefined || chatbotMessage['name'] === "") {
            showToast("Name is Mantory", "", "error");
            return;
        }
        //chatbotMessages = Array.from(new Map(chatbotMessages.map(item => [item.id, item])).values());
        let params = {
            "ENTITY": "WHATSAPPPROCESS",
            "OPERATION": "SAVE_CHATBOT_MESSAGES",
            "FORMID": formData['table_66_id'],
            "FORMINPUT": chatbotMessage,
            "MESSAGEID": selectedChatbotMSG,
            "isOtherApiReq": true,
        }
        let response = await requestApi.processServerRequest(params, "WebV2", "post");
        if (response.issuccess) {
            let data = response.data;
            let msgId = data[0];
            let orderMsg = [];

            let { chatbotMessageIds } = this.state;
            chatbotMessageIds.push(msgId);
            chatbotMessage['id'] = msgId;
            chatbotMessages = chatbotMessages.map(item => (item.id === msgId ? chatbotMessage : item));
            if (selectedChatbotMSG === "") {
                chatbotMessages.push(chatbotMessage);
            }
            const length = Object.keys(updateLeadConfig).length;
            if (length > 0) {
                    for (let i = 0; i < length; i++){
                    let updateLeadCon = updateLeadConfig[i];
                    let messageorder = updateLeadCon && updateLeadCon['message_order'] !== undefined ? updateLeadCon['message_order'] : [];
                    let orderValueArr = messageorder['value'] !== undefined ? messageorder['value'].split('-') : [];
                    if (parseInt(orderValueArr[1]) === parseInt(selectedChatbotMSG)) {
                    	if(orderValueArr[0] == 'UR'){
                            updateLeadConfig[i]['message_order']['label'] = 'Update Response - ' + chatbotMessage['name'];
                        }else if(orderValueArr[0] == 'CV'){
                            updateLeadConfig[i]['message_order']['label'] = 'Custom Value - ' + chatbotMessage['name'];
                        }/*  else{
                              updateLeadConfig[i]['message_order']['label'] = chatbotMessage['name'];
                         }  */
                        
                    }
                }
            }
            for (let i = 0; i < chatbotMessages.length; i++) {
                orderMsg.push(
                    { 'label': 'Update Response - ' + chatbotMessages[i].name, 'value': 'UR-' + chatbotMessages[i].id, 'group': 'update_response' },
                );
            };
            for (let i = 0; i < chatbotMessages.length; i++) {
                orderMsg.push(
                    { 'label': 'Custom Value - ' + chatbotMessages[i].name, 'value': 'CV-' + chatbotMessages[i].id, 'group': 'custom_value' }
                );
            };
            this.setState({
                chatbotMessages,
                chatbotMessageIds,
                messageOrder: orderMsg,
            });
            this.cancelChatbotMSG();
            //this.getChatBotReplyMessage();
            // window.location.reload();
        }
    }

    dummySubmit = (data) => {
        this.submitWPRef.current.click();
    }

    render() {

        let { showModal, oncancel, formId, leadFormDetail, waOptions } = this.props;

        let { type, isModal, isChatbotModel, components, waComponents, previewData, formData, channelRecipientOptions, recipientOptions,selectedTemplate,selectedFormDetails } = this.state;
        const { handleSubmit: handleActionFormSubmit, control, formState: { errors } } = this.props.useForm;
        let buttonIcon = "pe-7s-diskette";
        let addonButtons = [];
        let header = 'Add Quick Reply';
        let btnText = 'Add Reply';

        if (type === 'auto-reply') {
            header = 'New Bot Reply';
            btnText = 'Save & Close';
        }
        if (formId !== undefined && formId !== '' && formId != null) {
            header = 'Update Message';
            btnText = 'Update';

            if (type === 'auto-reply') {
                header = 'Update Bot Reply';
                btnText = 'Save & Close';
            }
        }
        if (type === "optout_message" || type === "optin_message") {
            header = 'Configure Message';
            btnText = 'Save Configuration';
        }
        if (type === "waNotification" || type === "workflowAction") {
            header = 'Notification Message';
            btnText = 'Save & Close';
        }

        if (isModal) {
            return (
                <Fragment>
                    {type !== "workflowAction" && <Modal size={type === 'auto-reply' || type === 'waNotification' ? 'lg' : 'md'} isOpen={showModal} toggle={oncancel} >
                        <form name={'qiuckreply'} onSubmit={(e) => { return this.submitForm(e) }}>
                            <ModalHeader toggle={oncancel}>
                                {header}
                            </ModalHeader>
                            <ModalBody>
                                {this.getReplyTemplateContent()}
                            </ModalBody>
                            <ModalFooter>
                                <Button className={`le-button lePrimaryBtn br-4`} color="primary" type={'submit'}>
                                    {btnText}
                                </Button>
                            </ModalFooter>
                        </form>
                    </Modal>
                    }
                    {
                        type === "workflowAction" &&
                        <Modal isOpen={showModal} toggle={this.toggleActionEditorModal}
                            className={'le-modal-lg campaign-modal'}>
                            <ModalBody>
                                <WhatsappAction 
                                    formData={formData}
                                    waOptions={waOptions}
                                    triggerSubmit={this.triggerSubmit}
                                    oncancel={oncancel}
                                    showModal={showModal}
                                    handleChange={this.handleChange}
                                    recipientOptions={recipientOptions}
                                    channelRecipientOptions={channelRecipientOptions}
                                    onRecipientsChange={this.onRecipientsChange}
                                    selectedTemplate={selectedTemplate}
                                    handleTemplateChange={this.handleTemplateChange}
                                    waComponents={waComponents}
                                    components={components}
                                    onFileUpload={this.onFileUpload}
                                    handleVariableChange={this.handleVariableChange}
                                    previewData={previewData}
                                    leadFormDetail={selectedFormDetails}
                                    submitRef={this.submitRef}
                                    submitForm={this.submitForm}
                                />
                            </ModalBody>
                        </Modal>
                    }
                </Fragment>
            );
        }

        return (
            <Common pageTitle={"Chat Bot"} showLoader={this.state.showLoader} mainContent={
                <Fragment>
                    <form name={'qiuckreply'} onSubmit={(e) => { return this.submitForm(e) }}>
                        <CommonHeaderContent
                            addonButtons={addonButtons}
                            buttonAction={this.triggerSubmit}
                            buttonIcon={buttonIcon}
                            headerTitle={header}
                            cancelBtn={true}
                            cancelURL={'chatbots'}
                            buttonTxt={btnText}
                            mainContent={
                                <div className={`newautomation-panel`}>
                                    <div className={`row`}>
                                        <div className={`col-md-12`}>
                                            <div className={`container`}>
                                                {this.getReplyTemplateContent()}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            } />
                        <button ref={this.submitRef} className={`le-button lePrimaryBtn br-4 hide`} color="primary" type={'submit'}>
                            {btnText}
                        </button>
                    </form>
                </Fragment>
            } />
        )
    }
}

export default ReplyTemplate;